import React from 'react';

export const expandCard = (event: React.MouseEvent<HTMLDivElement>) => {
  const itemClicked = event.currentTarget.classList;
  if (itemClicked.contains('gabrr_expanded')) return closeAllCards();
  closeAllCards();
  return itemClicked.add('gabrr_expanded');
};

export const closeAllCards = () => {
  document.querySelectorAll('.gabrr_expanded').forEach((el) => el.classList.remove('gabrr_expanded'));
};
